import request from '@/utils/request'

export function getGoodsList(data) {
     return request({
         url:'/store/manage/list',
         method:'put',
         data:data
     });
 }

 export function updateRemark(params) {
     return request({
         url:'/store/manage/updateRemark',
         method: 'post',
         params:params
     })
 }

 export function deleteByCommIds(data) {
     return request({
         url:'/store/manage/delete',
         method:'delete',
         data:data
     })
 }

//根据Id数组批量删除
export function batchDelete(commIds) {
    return request({
        url: '/store/manage/'+commIds,
        method: 'delete',
    })
}

//根据ids和需要修改的值进行批量修改
export function batchUpdate(params) {
    return request({
        url:'/store/manage/moveCommType',
        method: 'post',
        params:params
    })
}

//查询全部,单品,多变种的数量
export function getAllTypeCount() {
    return request({
        url:'/store/manage/getAllTypeCount',
        method:'get',
    });
}
//将商品移动到指定仓库
export function moveToStore(data) {
    return request({
        url:'/store/manage/moveToStore',
        method:'put',
        data:data
    })
}

//查询父商品
export function getManyListById(params) {
    return request({
        url:'/store/manage/getManyListById',
        method:'get',
        params:params
    });
}
//根据商品id获取平台sku
export function getPlatSku(id) {
    return request({
        url:'/store/manage/'+id + '/platSku',
        method:'get'
    })
}

//查询子商品
export function getManyChildListById(params) {
    return request({
        url:'/store/manage/getManyChildListById',
        method:'get',
        params:params
    });
}
export function savePlatSku(data) {
    return request({
        url:'/store/manage/updatePlatSku',
        method:'put',
        data:data
    })
}

//查询子商品ids
export function getChildrenId(params) {
    return request({
        url:'/store/manage/getChildrenId',
        method:'get',
        params:params
    });
}


//根据父ID,删除所有的子商品和本身
export function deleteCommIdAllData(commId) {
    return request({
        url: '/store/manage/deleteCommIdAllData'+commId,
        method: 'delete',
    })
}

//根据用户名查找仓库列表
export function selectWareListRadio() {
    return request({
        url:'/store/manage/selectWareListRadio',
        method:'get',
    });
}

//新增商品
export function save(data) {
    return request({
        url:'/store/manage/save',
        method:'put',
        data:data
    });
}

//根据Id数组批量删除
export function getManyGoods(commId) {
    return request({
        url: '/store/manage/getManyGoods/'+commId,
        method: 'get',
    })
}

//根据commId获取所有的属性
export function getAttrListByCommId(commId) {
    return request({
        url: '/store/attr/getAttrListByCommId/'+commId,
        method: 'get',
    })
}

//根据commPId获取子级商品
export function getGoodsListByCommPId(commPId) {
    return request({
        url: '/store/manage/getGoodsListByCommPId/'+commPId,
        method: 'get',
    })
}

//批量保存goods
export function batchUpdataGoods(data) {
    return request({
        url:'/store/manage/batchUpdataGoods',
        method:'put',
        data:data
    });
}

//获取表自增的实时最大值-
export function getMaxId(data) {
    return request({
        url:'/store/manage/getMaxId',
        method:'get',
    });
}

//新增单个SKU
export function addSingleGoods(data) {
    return request({
        url:'/store/manage/addSingleGoods',
        method:'put',
        data:data
    });
}


//根据commId获取商品信息
export function getSingleGoods(commId) {
    return request({
        url: '/store/manage/getSingleGoods/'+commId,
        method: 'get',
    })
}

//编辑单个SKU
export function editSingleGoods(data) {
    return request({
        url:'/store/manage/editSingleGoods',
        method:'put',
        data:data
    });
}





